import React, { useEffect, useState } from "react";
import SideBar from "../../Common/SideBar";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import {
  collection,
  deleteDoc,
  doc,
  getDoc,
  onSnapshot,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import {
  accountType,
  convertTimestampToDate,
  firestoreCollections,
  projectStatus,
} from "../../../utils";
import { db } from "../../../config/firebase";
import { errorToast, successToast } from "../../../services/toastService";
import { sendNotification } from "../../../services/firebaseService";

export default function VerifyProjectScreen() {
  const sidebar = useSelector((state) => state.sidebar);
  const dispatch = useDispatch();
  const [timeFrame, setTimeFrame] = useState("Day");
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [projectRequests, setProjectRequests] = useState([]);
  const [activeProjectData, setActiveProjectData] = useState({});
  const [approveLoading, setApproveLoading] = useState(false);
  const [denyLoading, setDenyLoading] = useState(false);
  const [declineTextAreaActive, setDeclineTextAreaActive] = useState(false);
  const [declineMerchText, setDeclineMerchText] = useState("");

  const CloseAddCategory = () => {
    setModalIsOpen(false);
    setDeclineTextAreaActive(false);
    setDeclineMerchText("");
  };

  const fetchProjectRequests = () => {
    const q = query(
      collection(db, firestoreCollections.customerProjects),
      where("status", "==", projectStatus.POSTED),
      where("adminApproved", "==", false)
    );

    const unsubscribe = onSnapshot(q, async (querySnapshot) => {
      const newData = await Promise.all(
        querySnapshot.docs.map(async (projectDoc) => {
          const projectData = projectDoc.data();
          const customerId = projectData.uploadedBy;

          if (customerId) {
            const customerDoc = await getDoc(
              doc(db, firestoreCollections.customers, customerId)
            );
            if (customerDoc.exists()) {
              const customerData = customerDoc.data();
              projectData.uploadedByData = customerData; // Add customer data to project object
            }
          }

          return {
            ...projectData,
            id: projectDoc.id,
          };
        })
      );

      setProjectRequests(newData);
    });

    return unsubscribe; // Return the unsubscribe function to detach the listener when needed
  };

  useEffect(() => {
    const unsubscribe = fetchProjectRequests();

    return () => {
      unsubscribe(); // Detach the listener when the component unmounts
    };
  }, []);

  const handleProjectApprove = async (projectId, uploadedBy) => {
    if (!denyLoading) {
      try {
        setApproveLoading(true);
        const docRef = doc(
          db,
          firestoreCollections.customerProjects,
          projectId
        );
        const updatedData = {
          status: projectStatus.POSTED,
          adminApproved: true,
        };
        await updateDoc(docRef, updatedData);

        const notificationData = {
          title: "Congratulations! Your project has been approved by admin.✅",
          body: "Our partners can now bid on your project.",
          accType: accountType.CUSTOMER,
          userId: uploadedBy,
        };
        sendNotification(notificationData);

        successToast("Project approved successfully.");
        setActiveProjectData({});
        setModalIsOpen(false);
      } catch (error) {
        errorToast("Internal server error");
        console.log(error, "<<< error approving project");
      } finally {
        setApproveLoading(false);
      }
    }
  };

  const handleProjectDeny = async (projectId, uploadedBy) => {
    if (!approveLoading) {
      if (!declineMerchText) {
        errorToast("Please specify reason to decline project.");
        return;
      }
      try {
        setDenyLoading(true);
        const docRef = doc(
          db,
          firestoreCollections.customerProjects,
          projectId
        );
        const updatedData = {
          status: projectStatus.ADMIN_DECLINED,
          declineReason: declineMerchText,
        };
        await updateDoc(docRef, updatedData);

        const notificationData = {
          title: "Your project has been denied by admin.",
          body: "Please make necessary changes to your project and submit again.",
          accType: accountType.CUSTOMER,
          userId: uploadedBy,
        };
        sendNotification(notificationData);

        successToast("Project rejected successfully.");
        setActiveProjectData({});
        setDeclineMerchText("");
        setModalIsOpen(false);
      } catch (error) {
        errorToast("Internal server error");
        console.log(error, "<<< error approving project");
      } finally {
        setDenyLoading(false);
      }
    }
  };

  return (
    <div className="MainContainer">
      <SideBar />
      <div
        style={{ width: sidebar.expand ? "84vw" : "95vw" }}
        className="ScreenContainer"
      >
        {/* upper search bar start */}

        <div className="upperSearchBarContainer">
          <div className="upperBarSearchBar">
            <div className="pageHeadingInnerContainer">
              {/* <img
                src={require("../../../assets/dashboardColourIcon.png")}
                alt="profile-pic"
                className="pageHeadingImageDashboard"
              /> */}
              <div className="pageHeading">Project Verification</div>
            </div>
          </div>

          <div
            className="upperBarSearchBox upperBarSearchBoxProfile"
            style={{ border: "none" }}
          >
            <img
              src={require("../../../assets/profile.png")}
              alt="profile-pic"
            />
          </div>
          <div className="upperBarSearchBox upperBarSearchBoxNotification">
            <img
              src={require("../../../assets/exit.png")}
              alt="notification-bell"
            />
          </div>
        </div>
        <div
          className="upperSearchBarContainer"
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "1.5vh",
          }}
        >
          <input placeholder="Search..." className="upperBarSearchBarInput" />
          <div className="searchButton">Search</div>
        </div>

        {/* upper search bar ends */}

        {/* table starts here */}

        <div className="verificationTableContainer">
          <div className="verificationTableRow">
            <div
              style={{ width: "10%", height: "100%" }}
              className="eachColumn eachTableHead"
            >
              Sr. No.
            </div>
            <div
              style={{ width: "18%", height: "100%" }}
              className="eachColumn eachTableHead"
            >
              Title
            </div>
            <div
              style={{ width: "18%", height: "100%" }}
              className="eachColumn eachTableHead"
            >
              Budget
            </div>
            <div
              style={{ width: "18%", height: "100%" }}
              className="eachColumn eachTableHead"
            >
              Proposal Deadline
            </div>
            <div
              style={{ width: "18%", height: "100%" }}
              className="eachColumn eachTableHead"
            >
              Project Deadline
            </div>
            {/* <div
              style={{ width: "15%", height: "100%" }}
              className="eachColumn eachTableHead"
            >
              Type
            </div> */}
            <div
              style={{ width: "18%", height: "100%" }}
              className="eachColumn eachTableHead"
            >
              View Details
            </div>
          </div>
          {projectRequests.map((item, i) => (
            <div
              className="verificationTableRow"
              key={i}
              style={{
                backgroundColor: i % 2 == 0 ? "#6b5acd0e" : "#6b5acd1d",
              }}
            >
              <div
                style={{ width: "10%", height: "100%" }}
                className="eachColumn eachTableBody"
              >
                {i + 1}
              </div>
              <div
                style={{
                  width: "18%",
                  height: "100%",
                  textDecoration: "underline",
                  whiteSpace: "nowrap",
                }}
                className="eachColumn eachTableBody"
              >
                {item.title.slice(0, 25)}
              </div>
              <div
                style={{ width: "18%", height: "100%" }}
                className="eachColumn eachTableBody"
              >
                {item.budget.from}-{item.budget.to} SAR
              </div>
              <div
                style={{ width: "18%", height: "100%" }}
                className="eachColumn eachTableBody"
              >
                {convertTimestampToDate(item.proposalDeadline)}
              </div>
              <div
                style={{ width: "18%", height: "100%" }}
                className="eachColumn eachTableBody"
              >
                {convertTimestampToDate(item.deadline)}
              </div>
              {/* <div
                style={{ width: "15%", height: "100%" }}
                className="eachColumn eachTableBody"
              >
                {item.type}
              </div> */}
              <div
                style={{
                  width: "18%",
                  height: "100%",
                  textDecoration: "underline",
                  color: "#3366CC",
                }}
                className="eachColumn eachTableBody"
                onClick={() => {
                  setActiveProjectData(item);
                  setModalIsOpen(true);
                }}
              >
                View Project
              </div>
            </div>
          ))}
        </div>

        {/* table ends here */}
      </div>

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={CloseAddCategory}
        className="modalContainer"
      >
        <div className="merchantDetailModalContainer">
          <div className="merchantDetailModalProfileContainer">
            {/* <div>
                    <img
                      src={require("../../../assets/profile.png")}
                      alt="profile"
                      className="modalProfilePic"
                    />
                  </div> */}
            <div
              className="modalProfileNameContainer"
              style={{ marginLeft: "0%" }}
            >
              <div
                style={{
                  fontSize: "2.4vh",
                  fontFamily: "Poppins",
                  fontWeight: 600,
                }}
              >
                {activeProjectData?.title}
              </div>
              <div
                style={{
                  fontSize: "1.9vh",
                  fontFamily: "Poppins",
                  fontWeight: 600,
                  color: "#565656",
                  marginTop: "1%",
                }}
              >
                Budget : {activeProjectData?.budget?.from}-
                {activeProjectData?.budget?.to} SAR
              </div>
            </div>
          </div>
          <div className="modalFeildContainer">
            <div
              style={{
                fontSize: "1.8vh",
                fontFamily: "Poppins",
                fontWeight: 600,
              }}
            >
              Customer Name
            </div>
            <div
              style={{
                fontSize: "1.6vh",
                fontFamily: "Poppins",
                fontWeight: 500,
                color: "#565656",
              }}
            >
              {activeProjectData?.uploadedByData?.displayName}
            </div>
          </div>
          <div className="modalFeildContainer">
            <div
              style={{
                fontSize: "1.8vh",
                fontFamily: "Poppins",
                fontWeight: 600,
              }}
            >
              Customer Phone Number
            </div>
            <div
              style={{
                fontSize: "1.6vh",
                fontFamily: "Poppins",
                fontWeight: 500,
                color: "#565656",
              }}
            >
              {activeProjectData?.uploadedByData?.phoneNumber}
            </div>
          </div>
          <div className="modalFeildContainer">
            <div
              style={{
                fontSize: "1.8vh",
                fontFamily: "Poppins",
                fontWeight: 600,
              }}
            >
              Customer Email
            </div>
            <div
              style={{
                fontSize: "1.6vh",
                fontFamily: "Poppins",
                fontWeight: 500,
                color: "#565656",
              }}
            >
              {activeProjectData?.uploadedByData?.email}
            </div>
          </div>
          <div className="modalFeildContainer">
            <div
              style={{
                fontSize: "1.8vh",
                fontFamily: "Poppins",
                fontWeight: 600,
              }}
            >
              Proposal Deadline
            </div>
            <div
              style={{
                fontSize: "1.6vh",
                fontFamily: "Poppins",
                fontWeight: 500,
                color: "#565656",
              }}
            >
              {convertTimestampToDate(activeProjectData?.proposalDeadline)}
            </div>
          </div>
          <div className="modalFeildContainer">
            <div
              style={{
                fontSize: "1.8vh",
                fontFamily: "Poppins",
                fontWeight: 600,
              }}
            >
              Project Completion Deadline
            </div>
            <div
              style={{
                fontSize: "1.6vh",
                fontFamily: "Poppins",
                fontWeight: 500,
                color: "#565656",
              }}
            >
              {convertTimestampToDate(activeProjectData?.deadline)}
            </div>
          </div>
          <div className="modalFeildContainer">
            <div
              style={{
                fontSize: "1.8vh",
                fontFamily: "Poppins",
                fontWeight: 600,
              }}
            >
              Description
            </div>
            <div
              style={{
                fontSize: "1.6vh",
                fontFamily: "Poppins",
                fontWeight: 500,
                color: "#565656",
              }}
            >
              {activeProjectData?.description}
            </div>
          </div>
          <div className="modalFeildContainer">
            <div
              style={{
                fontSize: "1.8vh",
                fontFamily: "Poppins",
                fontWeight: 600,
              }}
            >
              Project Address
            </div>
            <div
              style={{
                fontSize: "1.6vh",
                fontFamily: "Poppins",
                fontWeight: 500,
                color: "#565656",
              }}
            >
              {activeProjectData?.projectAddress}
              {/* Dummy address */}
            </div>
          </div>
          <div className="projectGalleryMerchantModal">
            {activeProjectData?.projectImages?.map((uri) => (
              <a style={{ marginRight: "3%" }} href={uri} target="_blank">
                <img
                  src={uri}
                  alt="profile"
                  className="projectGalleryMerchantModalPic"
                />
              </a>
            ))}
          </div>
          <div className="modalButtonContainer">
            {approveLoading ? (
              <div className="buttonEachModal buttonEachModalPrimary">
                <div
                  style={{
                    fontSize: "1.8vh",
                    fontFamily: "Poppins",
                    fontWeight: 600,
                    color: "white",
                  }}
                >
                  loading...
                </div>
              </div>
            ) : (
              <div
                className="buttonEachModal buttonEachModalPrimary"
                onClick={() =>
                  handleProjectApprove(
                    activeProjectData.id,
                    activeProjectData.uploadedBy
                  )
                }
                style={{
                  opacity: denyLoading ? 0.5 : 1,
                }}
              >
                <div
                  style={{
                    fontSize: "1.8vh",
                    fontFamily: "Poppins",
                    fontWeight: 600,
                    color: "white",
                  }}
                >
                  Approve
                </div>
              </div>
            )}
            {denyLoading ? (
              <div
                className="buttonEachModal buttonEachModalSecondary"
                style={{
                  // opacity: 0.3,
                  borderColor: approveLoading ? "gray" : "#03baf9",
                }}
              >
                <div
                  style={{
                    fontSize: "1.8vh",
                    fontFamily: "Poppins",
                    fontWeight: 600,
                    color: "#03baf9",
                  }}
                >
                  loading...
                </div>
              </div>
            ) : (
              <div
                className="buttonEachModal buttonEachModalDecline"
                style={{
                  // opacity: 0.3,
                  borderColor: approveLoading ? "gray" : "rgb(185, 22, 22)",
                }}
                onClick={() => setDeclineTextAreaActive(true)}
              >
                <div
                  style={{
                    fontSize: "1.8vh",
                    fontFamily: "Poppins",
                    fontWeight: 600,
                    color: approveLoading ? "gray" : "rgb(185, 22, 22)",
                  }}
                >
                  Decline
                </div>
              </div>
            )}
          </div>
          {declineTextAreaActive && (
            <>
              <div
                style={{
                  fontSize: "1.8vh",
                  fontFamily: "Poppins",
                  fontWeight: 600,
                  color: "black",
                  marginBottom: "1vh",
                }}
              >
                Please specify reason for decline (max. 200 characters) :
              </div>
              <textarea
                maxLength={200}
                className="modaDeclineTextArea"
                placeholder="Reason"
                onChange={(e) => setDeclineMerchText(e.target.value)}
              />
              <div className="modalButtonContainer">
                {denyLoading ? (
                  <div className="buttonEachModal buttonEachModalPrimaryDecline">
                    <div
                      style={{
                        fontSize: "1.8vh",
                        fontFamily: "Poppins",
                        fontWeight: 600,
                        color: "white",
                      }}
                    >
                      loading...
                    </div>
                  </div>
                ) : (
                  <div
                    className="buttonEachModal buttonEachModalPrimaryDecline"
                    onClick={() =>
                      handleProjectDeny(
                        activeProjectData.id,
                        activeProjectData.uploadedBy
                      )
                    }
                  >
                    <div
                      style={{
                        fontSize: "1.8vh",
                        fontFamily: "Poppins",
                        fontWeight: 600,
                        color: "white",
                      }}
                    >
                      Decline
                    </div>
                  </div>
                )}
                <div
                  className="buttonEachModal buttonEachModalDecline"
                  onClick={() => {
                    if (!denyLoading) {
                      setDeclineTextAreaActive(false);
                      setDeclineMerchText("");
                    }
                  }}
                >
                  <div
                    style={{
                      fontSize: "1.8vh",
                      fontFamily: "Poppins",
                      fontWeight: 600,
                      color: "rgb(185, 22, 22)",
                    }}
                  >
                    Cancel
                  </div>
                </div>
              </div>
            </>
          )}
          <div onClick={CloseAddCategory}>
            <img
              src={require("../../../assets/crossIcon.png")}
              alt="profile"
              className="modalCross"
            />
          </div>
        </div>
      </Modal>
    </div>
  );
}
